import type { ErrorMonitor } from './cairoMonitor';
import { fetchTranslations } from './fetchTranslations';

export const prefetchTranslations =
  (params: { readonly errorMonitor: ErrorMonitor }) => (locale: string) => {
    return fetchTranslations(params)(locale);
  };
